<template>
    <div class="ly-text" v-if="isDisplay">
        <a :href="href" target="_blank" v-if="attrs.type == 'url'">{{value}}</a>
        <div v-else-if="attrs.type == 'array'">
            <div v-for="(el,i) in value" :key="i">{{el}}</div>
        </div>
        <label v-else>{{bindText || bindVal}}</label>

    </div>
</template>
<script>
/**
 * 2020-9-18 modify by wxf
 * 增加条件判断是否显示组件
 */
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    import {mapGetters} from 'Vuex'
    export default {
        name: 'LyText',
        mixins: [CompDisplayMixin],
        props: {
            value: {
                type: [String, Number, Boolean, Array],
                default: ''
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            },
            row: {
                type: Object,
                default: _ => new Object()
            }, // 表格中传入的数据
            page: {
                type: Object,
                default:_ => new Object()
            }
        },
        data () {
            return {
                // bindText: '',
                rangeValue: '',
                bindVal: ''
            }
        },
        computed: {
            ...mapGetters(['userInfo']),
            href () {
                let txt = this.value
                if (this.attrs.type == 'url') {
                    //是否有url的配置
                    if (this.attrs.urlField && this.row[this.attrs.urlField]) {
                        txt =  this.row[this.attrs.urlField]
                    }
                    if (txt.indexOf('http://') < 0 && txt.indexOf('https://') < 0) {
                        txt = 'http://' + txt
                    }
                }
                return txt
            },
            bindText: {
                get() {
                    let txt = ""
                    if(this.attrs.accountField && this.attrs.accountField.length > 0 && this.userInfo.hasOwnProperty(this.attrs.accountField)) {
                        txt = this.userInfo[this.attrs.accountField]
                    } else if(this.attrs.linkField){ // 2020-09-18修改联动字段显示数据（目前只做了与select-search联动）
                        this.$eventHub.$on(this.attrs.linkField + 'LinkEvent', val => {
                            txt = val[this.attrs.field]
                        })
                    } else {
                        txt = this.value
                    }
                    return txt
                },
                set(val) {
                    this.$eventHub.$emit(this.attrs.field, val)// 全局监听 modify by wxf 2020-11-13 cpc消费明细列表编辑(消费落地页联动search)
                    this.bindVal = val
                }
            }
        },
        mounted() {
            // 写在这里是解决cpc agent消费新增下，数据不联动 2020-09-21 by wxf
            if(this.attrs.linkField){ // 2020-09-18修改联动字段显示数据（目前只做了与select-search联动）
                this.$eventHub.$on(this.attrs.linkField + 'LinkEvent', val => {
                    this.bindVal = val[this.attrs.field]
                })
            }
        }
    }
</script>
<style>
    .ly-text {
        display: inline-block;
    }
    .ly-text a {
        color: #2d8cf0;
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/text/src/index.vue